// extracted by mini-css-extract-plugin
export default {"formWrapper":"SizeNotificationsForm_formWrapper__33EKs"};